export const BACKGROUND_PRYMARY_LIGHT = '#ffffff';
export const BACKGROUND_PRYMARY_DARK = '#000000';

export const CONTENT_PRYMARY = '#000000';
export const CONTENT_PRYMARY_LIGHT = '#aaaaaa';
export const CONTENT_PRYMARY_DARK = '#000000';

export const CONTENT_SECONDARY = '#e57373';
export const CONTENT_SECONDARY_LIGHT = '#ea8f8f';
export const CONTENT_SECONDARY_DARK = '#a05050';
